import { IsNumberOptions } from "class-validator";

export class ProductionLogRequest {
  lotNumber: string;
  fromDate?: any;
  toDate?: any;
  unitId?: number;
  operation?:string
  year?:number
}
